import { FC } from "react";
import { awdApi } from "store/reducers/awdApi";
import { Stack } from "components/layout/Stack";
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import { AirportAccessCountDataPoint } from "awd-server-api";
import { ROW_PER_PAGE, StyledTableCell, StyledTableRow, useTablePage } from "utils/table";

type AirportAccessCountsProps = {};

export const AirportAccessCount: FC<AirportAccessCountsProps> = (props) => {
  const [ page,, handleChangePage ] = useTablePage();

  const { data, isLoading } = awdApi.endpoints?.getStatisticsAirportAccessCount.useQuery();

  const download = () => {
    if (data) {
      const csvData = data.airportAccessCount
        .map((item) => `${item.name},${item.icao},${item.access_count}`)
        .join("\n");

      const blob = new Blob([`Airport Name,ICAO,Access Count\n${csvData}`], {
        type: "text/csv",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Airport Access Counts ${new Date().toLocaleDateString()}.csv`;
      a.click();
      window.URL.revokeObjectURL(url);
    }
  };

  const paginatedData = data?.airportAccessCount?.slice(page * ROW_PER_PAGE, (page + 1) * ROW_PER_PAGE);

  if (isLoading) return null;
  return (
    <div>
      <Stack horizontal gap={"0"} css={{ justifyContent: "space-between" }}>
        <Button onClick={download}>Download Airport Access Counts Data</Button>
      </Stack>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell>Airport Name</StyledTableCell>
              <StyledTableCell>ICAO</StyledTableCell>
              <StyledTableCell>Airport Access Count</StyledTableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {paginatedData?.map((airport) => (
              <AirportAccessTableRow key={airport.icao} airport={airport} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[]}
        component="div"
        count={data?.airportAccessCount?.length ?? 0}
        rowsPerPage={ROW_PER_PAGE}
        page={page}
        onPageChange={handleChangePage}
        showFirstButton
        showLastButton
      />
    </div>
  );
};

type HomeAirportTableRowProps = {
  airport: AirportAccessCountDataPoint;
};

const AirportAccessTableRow: FC<HomeAirportTableRowProps> = ({ airport }) => {
  return (
    <StyledTableRow>
      <StyledTableCell>{airport.name}</StyledTableCell>
      <StyledTableCell>{airport.icao}</StyledTableCell>
      <StyledTableCell>{airport.access_count}</StyledTableCell>
    </StyledTableRow>
  );
};
